/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HolidayDates} from '../model/helper/holiday-dates';
declare var moment: any;

@Injectable()
export class CalculationService {

  getDueDateRegular(date, days): Date {
    return CalculationService.getDueDate(date, days);
  }

  static getDueDate(date, days): Date {
    if(!date) return null;
    return CalculationService.businessAdd(moment(date), days).toDate();
  }

  private static businessAdd(moment: any, days: number): any {
    let date = moment.clone();

    while (days > 0) {
      date = date.add(1, 'days');
      // decrease "days" only if it's a weekday AND not an admin-managed holiday
      if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7 && !HolidayDates.isHoliday(date))
        days -= 1;
    }
    return date;
  }
}
